// F-13 — the gift "milestone whisper" on the Reveal kept screen fires ONLY at pride peaks,
// matching the story_milestone GA4 event (counts 2, 5, 10). The ask lives at those peaks only
// (§6b) — never on ordinary saves. One source of truth for the gate so it stays testable.
export const GIFT_WHISPER_MILESTONES = [2, 5, 10];

export function isGiftWhisperMilestone(chapterCount) {
  return GIFT_WHISPER_MILESTONES.includes(chapterCount);
}
